import React from 'react';
import {
  Box,
} from '@mui/material';
import { GTSingleChoicePayload, QuestionSingleChoice } from '../../redux/types';

type Props = {
  payload: GTSingleChoicePayload;
  question: QuestionSingleChoice;
};

const GTSingleChoiceScore: React.FC<Props> = ({
  question,
  payload,
}: Props) => (
  <Box>
    {
      question.payload?.filter((op) => {
        const score = payload[op.id];
        return !!score;
      }).map((op) => (
        <Box key={op.id}>
          {`${op.text} (${payload[op.id]})`}
        </Box>
      ))
    }
  </Box>
);

export default GTSingleChoiceScore;
